import IconCoinsSolid from '@/assets/icons/font_awesome/coins-solid.svg?react';
import IconPercentSolid from '@/assets/icons/font_awesome/percent-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { get_sorted_current_workspace_users } from '@/utils/utils_workspace';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WSTableAllTimeCreditsHeader } from './WSTableAllTimeCreditsHeader';
import { WSTableAllTimeCreditsRow } from './WSTableAllTimeCreditsRow';

export function WSTableAllTimeCredits() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const [isCoins, setIsCoins] = useState(true);

  function render_view() {
    const users = get_sorted_current_workspace_users();

    if (users.length === 0) {
      return <TABLE__empty />;
    } else {
      return (
        <div className="flex flex-col justify-start items-center h-full w-full">
          <WSTableAllTimeCreditsRow is_coins={isCoins} users={users} />
        </div>
      );
    }
  }

  return (
    <div className="w-full">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2',
        )} mt-3 flex flex-col justify-center items-start border-b border-component-border text-page-foreground`}
      >
        <div className="text-xl">
          <UI_PRIMITIVE__button_with_icon_animated
            className="mr-2 p-0 "
            iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
            iconClassNameHovered="!text-bar-foreground"
            variant="no-border-on-component"
            Icon={isCoins ? IconCoinsSolid : IconPercentSolid}
            onClick={() => setIsCoins(!isCoins)}
            renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
          />
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_all_time.title)}
        </div>
        <div className={`${md('px-2 justify-start gap-2', ' pr-5 justify-start')} w-full min-h-[50px] flex flex-row items-center mt-2`}>
          <span className={`${md('min-w-[130px] text-[10px]', 'min-w-[220px]')} text-left flex items-center`}>
            <div className="w-[50px]" />
          </span>
          <WSTableAllTimeCreditsHeader />
        </div>

        <div className="w-full border-t border-component-item" />

        {render_view()}
      </div>
    </div>
  );
}
